import { useCallback } from "react";

import { MONOLITH_ORIGIN } from "@/monolithIntegration/monolithIntegration.constants";
import useRestMutation from "@/remoteState/useRestMutation";

const useUserPost = (defaultId) => {
  const setUser = useCallback(({ id = defaultId, ...payload }) => {
    return new Request(`${MONOLITH_ORIGIN}/api/v2/user/${id ? id + "/" : ""}`, {
      method: "POST",
      body: JSON.stringify(payload),
      headers: { "Content-Type": "application/json" },
    });
  }, []);

  return useRestMutation(setUser);
};

export default useUserPost;
